import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tool-history',
    templateUrl: './tool-history.component.html',
    styleUrls: ['./tool-history.component.scss']
})
export class ToolHistoryComponent implements OnInit {

    tabs = [
        {
            link: 'status',
            label: 'admin.tool-history.header.status'
        },
        {
            link: 'lifecycle',
            label: 'admin.tool-history.header.lifecycle'
        }
    ]

    constructor() {
    }

    ngOnInit() {
    }

}
